import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { useAppContext } from "../../../libs/app-core/AppContext";
import { Lang, SpwkUtil } from "../../dao/SpwkUtil";
import { UniAnswerDAO } from "../../dao/UniAnswerDAO";
import { useSpwkQuestV3 } from "./useSpwkQuestV3";
import { UniForm } from "../../dao/UniForm";
import { UniAnswer } from "../../dao/UniAnswer";
import { Box, Button, Container, Grid } from "@mui/material";
import { linear_content_style, linear_item, linear_v, } from "../../../libs/linear-layout/LinearLayout";
import UcStepper from "./UcStepper";
import UcLangPicker from "./UcLangPicker";
import { Toast } from "../../../libs/app-core/Toast";
import { UniQuestion } from "../../dao/UniQuestion";
import UcQuestionPanel from "../../components/uni/UcQuestionPanel";
import { MessageDialog } from "../../../libs/app-core/dialogs/MessageDialog";
import { GetChapterListByTabKey, GetTabKeyList } from "./tab_defines";
import CheckBox from "../../../libs/rhf-mui/ui/CheckBox";
import Label from "../../../libs/rhf-mui/ui/Label";
import { UiMetaTable } from "./UiMetaTable";
import { ROUTE_export_test } from "../../Routes";
import { Member } from "../../dao/Member";
import { useMember } from "../../dao/MemberDAO";
import { new_ErrorAlert } from "../../export_spwk/ExportManager";

/** 此頁面的輸入參數(預計透過url控制) */
export type FrmSpwkQuestProps = { answer_guid?: string; func_guid?: string; };

const FrmSpwkQuest = (props: FrmSpwkQuestProps) => {
  const ctx = useAppContext();

  //#region 以網址傳入的參數為主
  let params = useLocation().state as FrmSpwkQuestProps;
  if (params != null) {
    props = params;
  }
  //#endregion
  let answer_guid = params.answer_guid ?? undefined;
  let func_guid = params.func_guid ?? undefined;

  const [IsV3Split, set_IsV3Split] = useState(true); // 是否使用新版拆分
  const [IsRemoveEmptyQuestion, set_IsRemoveEmptyQuestion] = useState(true); // 是否移除沒有項目的題目
  const [IsAdjustOptions, set_IsAdjustOptions] = useState(true); // 依照 一般選項, 其他, 無 排序
  const [IsJudgeGender] = useState(false);
  let guid: string = '';
  if (answer_guid !== undefined) {
    guid = answer_guid
  }
  const { _Member } = useMember(guid)
  /* 核心變數: 此 Answer 與其通用問題 + 特作版本列表 */
  let { _UniAnswer, _SpwkBaseForm, _UniFormList } = useSpwkQuestV3(answer_guid, func_guid, IsV3Split, IsRemoveEmptyQuestion, IsAdjustOptions, IsJudgeGender); // $$$

  //#region UI相關變數
  const [LangA, setLangA] = useState<Lang>("CHI"); // 主要語言
  const [LangB, setLangB] = useState<Lang>(""); // 次要語言
  const uni_func_guids = _UniFormList == null ? [] : _UniFormList?.map((x) => x.func_guid);
  let TAB_KEY_LIST = GetTabKeyList(uni_func_guids); // 需要哪幾頁畫面
  const [CurrTabKey, set_CurrTabKey] = useState(TAB_KEY_LIST.length > 0 ? TAB_KEY_LIST[0] : ""); // 當前 TabPage
  //#endregion

  /** react-hook-form */
  const rhf = useForm<any>({
  });
  const [_UiMetaTable, set_UiMetaTable] = useState<UiMetaTable | undefined>(undefined);

  function LoadAllUiQuestions() {


    let meta_table = new UiMetaTable();

    if (_SpwkBaseForm != null && _UniFormList != null) {
      for (const tab of TAB_KEY_LIST) {
        const chapters = GetChapterListByTabKey(tab);

        for (const chapter of chapters) {
          let questions: UniQuestion[] = SpwkUtil.GetChapterQuestions(chapter, _SpwkBaseForm, _UniFormList, uni_func_guids);

          let meta_list = UiMetaTable.ConvertQuestionToMetaList(questions);

          meta_table.ConcatMetaList(meta_list);

        }
      }

      set_UiMetaTable(meta_table);

      console.log(meta_table.meta_rows);
    }

    Toast.Show(ctx, "LoadAllUiQuestions: " + meta_table.meta_rows.length);
  }






  useEffect(() => {
    const subscription = rhf.watch((value, { name, type }) => {
      // // TODO 單選題改變時，底下沒勾的Input要設為預設值
      // // TODO 多選題改變時，同上
      // // TODO 勾選無時，清空除了無之外的選項，並執行同上操作
      // // TODO 勾選非無 的選項，把無取消勾選，並執行同上
    });

    return () => {
      subscription.unsubscribe();
      return;
    };

  }, [rhf.watch, _UiMetaTable]);// 這裡放 AllUiQuestions 可能是錯的

  //#region  useEffect: Answer 準備好後，觸發 rhf.reset()
  useEffect(() => {
    async function async_func() {
      if (_UniAnswer === undefined) {
        return; // 還沒撈資料
      }

      if (_UniAnswer == null) {
        return; // 查無資料
      }

      let rhf_data = _UniAnswer.ConvertToSpwkRhfData();
      rhf.reset(rhf_data); // 讀檔。 將數值填入 rhf
    }

    async_func();
  }, [_UniAnswer === undefined ? undefined : _UniAnswer === null ? null : _UniAnswer.guid,]);
  //#endregion


  async function SaveData(rhf_data: any) {
    rhf_data = SpwkUtil.僅保留有Data中有輸入的數值(rhf_data);

    let answer: UniAnswer | undefined = undefined;

    MessageDialog.Show(ctx, JSON.stringify(rhf_data, null, 4), "是否保存?", {
      colorMeaning: "Success", yesText: "SAVE", cancelText: "取消",
      async onDialogResult(e) {
        if (e.DialogResult === "Yes") {
          if (_UniAnswer == null) {
            alert("不應該是 null !!!");
            return;
          } else {
            _UniAnswer.SetValueBySpwkRhfData(_UniAnswer.member_guid, rhf_data);
            await UniAnswerDAO.DB_Update(_UniAnswer);

            Toast.ShowScuccess(ctx, "Update OK.");
          }
        }
      },
    });
  }

  function OnInvalid(errors: any) {
    MessageDialog.Show(ctx, JSON.stringify(errors, null, 4), "Error", {
      colorMeaning: "Danger",
    });
  }

  //#region Blocker: 出現例外狀況
  if (_UniAnswer === null) {
    ctx.NavigateToErrorPage("", "Answer 查無資料!", "");
    return <>ERROR!</>;
  }

  if (_SpwkBaseForm === null) {
    ctx.NavigateToErrorPage("", "查無特作共用問題!!", "");
    return <>ERROR!</>;
  }
  //#endregion

  //#region Blocker: 變數尚未準備好
  if (_UniAnswer == null || _SpwkBaseForm == null || _UniFormList == null) {
    //2024-03-18  YAO 暫時拔除Loading...以解決翻譯問題
    return <></>;
  }
  //#endregion
  if (_Member === null || _Member === undefined) {
    throw new_ErrorAlert('794683' + '錯誤')
  }

  return render_Components(_SpwkBaseForm, _UniFormList, _UniAnswer, _Member);



  function render_Components(_SpwkBaseForm: UniForm, _UniFormList: UniForm[], _UniAnswer: UniAnswer, member: Member) {
    return (
      <Box style={linear_content_style}>
        <Grid {...linear_v}>
          <Grid {...linear_item} bgcolor="#CCCCCC">
            <Grid container direction={"row"} sx={{ px: 2 }}>
              <Label variant="caption">{"TODO 有Input合併時保留  "}</Label>
              <Label variant="caption">{"TODO 動態的無，目前沒有多國語言  "}</Label>
              <br />
              <CheckBox label={"拆分"}
                markProps={{
                  checked: IsV3Split,
                  onChange(event, checked) {
                    set_IsV3Split(checked);
                  },
                }}
              />
              <CheckBox label={"隱藏空題"}
                markProps={{
                  checked: IsRemoveEmptyQuestion,
                  onChange(event, checked) {
                    set_IsRemoveEmptyQuestion(checked);
                  },
                }}
              />
              <CheckBox label={"調整選項(順序,合併,隱藏拆分前,動態加入無)"}
                markProps={{
                  checked: IsAdjustOptions,
                  onChange(event, checked) {
                    set_IsAdjustOptions(checked);
                  },
                }}
              />
            </Grid>
          </Grid>

          {/* 左右切頁 Stepper */}
          <Grid {...linear_item} bgcolor="">
            <UcStepper CurrTabKey={CurrTabKey} set_CurrTabKey={set_CurrTabKey} TAB_KEY_LIST={TAB_KEY_LIST}
              OnStepperChanged={(curr_tab_key) => {
              }}
            />
          </Grid>

          {/* 特作問卷填寫區 */}
          <Grid {...linear_item} flex={1}>
            {render_Quest問卷表單區域(_SpwkBaseForm, _UniFormList, _UniAnswer, member)}
          </Grid>
        </Grid>
      </Box>
    );
  }

  function render_Quest問卷表單區域(_SpwkBaseForm: UniForm, _UniFormList: UniForm[], _UniAnswer: UniAnswer, member: Member) {
    if (_SpwkBaseForm == null) {
      return <>Error</>;
    }

    return (
      <Box style={linear_content_style}>
        <FormProvider {...rhf}>
          <form>
            <Container maxWidth="md" sx={{ pb: "128px" }}>
              {/* 錨點(為了切頁後移到最上方)*/}
              <div id="back-to-top-anchor"></div>

              {/* 語言 與 存檔按鈕 */}
              <Grid container alignItems={"center"}>
                <Grid item>
                  <UcLangPicker LangA={LangA} setLangA={setLangA} LangB={LangB} setLangB={setLangB} />
                </Grid>
                <Grid item>
                  <Button variant="contained" sx={{ mt: 1.5 }}
                    onClick={() => {
                      rhf.handleSubmit(
                        (data: any) => { SaveData(data); },
                        (errors: any) => { OnInvalid(errors); }
                      )();
                    }}
                  >
                    儲存
                  </Button>
                </Grid>

                <Grid item mx={2}>
                  <Button variant="contained" sx={{ mt: 1.5 }}
                    onClick={() => {
                      ctx.Navigate(ROUTE_export_test.url + "?answer_guid=" + answer_guid);
                      Toast.Show(ctx, "匯出測試");
                    }}
                  >
                    匯出測試
                  </Button>
                </Grid>

                <Grid item mx={2}>
                  <Button variant="contained" sx={{ mt: 1.5 }} color='error'
                    onClick={() => {
                      LoadAllUiQuestions();
                    }}
                  >
                    LoadAllUiQuestions
                  </Button>
                </Grid>


                <Grid item>
                  {func_guid == null ? undefined : (<div style={{ color: "#FF0000" }}>&nbsp;&nbsp;單一特作模式(禁止修改)</div>)}
                </Grid>
              </Grid>

              {/* 問卷題目區 */}
              <Grid container>
                {render_Questions當前頁面題目區域(uni_func_guids, CurrTabKey, _SpwkBaseForm, _UniFormList, LangA, LangB, member)}
              </Grid>
            </Container>
          </form>
        </FormProvider>
      </Box>
    );
  }

  /**
   * 原則上 TabKey 會與 章節名稱相同
   * 部分 TabPage 會同時繪製多個章節
   */
  function render_Questions當前頁面題目區域(func_guid_list: string[], CurrTabKey: string, _SpwkBaseForm: UniForm, _UniFormList: UniForm[], LangA: Lang, LangB: Lang, member: Member): JSX.Element[] {
    const chapters = GetChapterListByTabKey(CurrTabKey); // 1個Tab可能有多個 Chapter

    console.log("chapters: " + chapters);

    let elements: JSX.Element[] = [];
    for (const chapter of chapters) {
      // 對所有章節，繪製問題

      let questions: UniQuestion[] = SpwkUtil.GetChapterQuestions(chapter, _SpwkBaseForm, _UniFormList, func_guid_list);

      elements.push(
        <UcQuestionPanel key={chapter} questions={questions} member={member} LangA={LangA} LangB={LangB} />
      );
    }

    return elements;
  }
};

export default FrmSpwkQuest;
